module.exports = __webpack_public_path__ + "img/sii--icon.ec9b0d87.svg";